import AppNav from './AppNav'

function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-brand-cream">
      <AppNav />
      <main className="pb-20 sm:pb-0">{children}</main>
    </div>
  )
}

export default AppLayout
